import { PublicClientApplication } from '@azure/msal-browser';

import { msalConfig } from './msal';

let instance: PublicClientApplication | null = null;

/**
 * Process-wide MSAL instance, created lazily so that importing API modules
 * (which pull in the token provider) never constructs a real
 * PublicClientApplication in tests.
 */
export const getMsalInstance = (): PublicClientApplication => {
  if (!instance) {
    instance = new PublicClientApplication(msalConfig);
  }
  return instance;
};
